import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=46379b12&"
import script from "./ProductTab.vue?vue&type=script&lang=js&"
export * from "./ProductTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductTab.vue?vue&type=style&index=0&id=46379b12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports